import type { Feature } from 'geojson'
import {
  DEFAULT_GOOGLE_CAMERA_ANIMATION_DURATION_MS,
  normalizeRestoredDrawFeature,
} from '~/components'
import type { Search } from '~/models'
import { locationToFeature } from '~/models'
import { clearRememberedDrawnFeatureForBackNavigation } from '../../draw'
import type { AppMapDrawController, AppMapPadding, AppMapRef } from '../../google'

type OpenSavedSearchOptions = {
  map: AppMapRef | null | undefined
  mapDrawRef: AppMapDrawController | null | undefined
  padding?: AppMapPadding
  search: Search
  setDrawnFeature: (feature: Feature | null) => void
  setIsDrawOpen: (isOpen: boolean) => void
}

function moveMapToSearch(
  map: AppMapRef | null | undefined,
  search: Search,
  padding?: AppMapPadding
) {
  if (!map) return

  const center = [search.lng, search.lat] as [number, number]

  map.flyTo({
    center,
    duration: DEFAULT_GOOGLE_CAMERA_ANIMATION_DURATION_MS,
    padding,
    zoom: search.z,
  })
}

export function getSavedSearchDrawFeature(search: Search) {
  const geometry = search.location.$geoWithin.$geometry

  if (!('properties' in geometry)) return null

  return normalizeRestoredDrawFeature(locationToFeature(geometry))
}

export function openSavedSearch({
  map,
  mapDrawRef,
  padding,
  search,
  setDrawnFeature,
  setIsDrawOpen,
}: OpenSavedSearchOptions) {
  moveMapToSearch(map, search, padding)

  const feature = getSavedSearchDrawFeature(search)

  if (!mapDrawRef) {
    if (!feature) {
      clearRememberedDrawnFeatureForBackNavigation()
    }
    setDrawnFeature(feature)
    setIsDrawOpen(Boolean(feature))
    return
  }

  mapDrawRef.trash()
  mapDrawRef.deleteAll()

  if (!feature) {
    clearRememberedDrawnFeatureForBackNavigation()
    setDrawnFeature(null)
    setIsDrawOpen(false)
    return
  }

  setIsDrawOpen(true)
  setDrawnFeature(feature)
  mapDrawRef.add(feature)
}
